import { graphql } from '@/gql';
import type { GenerateRetentionLinkMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const generateRetentionLink = async (variables: GenerateRetentionLinkMutationVariables) => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation GenerateRetentionLink($autoDeactivateScheduledAt: DateTime!, $callerId: String!) {
        generateRetentionLink(autoDeactivateScheduledAt: $autoDeactivateScheduledAt, callerId: $callerId) {
          autoDeactivatePerformedAt
          autoDeactivateScheduledAt
          callerId
          code
          createdAt
          createdBy
          id
          updatedAt
        }
      }
    `),
    variables,
  });

  return response.data?.generateRetentionLink;
};
